import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  ApiRef,
  BackstageIdentityApi,
  ProfileInfoApi,
  SessionApi,
  OAuthApi,
  configApiRef,
  createApiFactory,
  createApiRef,
  fetchApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  googleAuthApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import {
  kubernetesApiRef,
  kubernetesAuthProvidersApiRef,
  KubernetesAuthProviders,
  KubernetesBackendClient,
} from '@backstage/plugin-kubernetes';
import {
  grafanaQueryApiRef,
  GrafanaQueryClient,
} from '@internal/plugin-grafana-dashboard';

export const giteaAuthApiRef: ApiRef<
  OAuthApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({ id: 'auth.gitea' });

export const githubAuthApiRef: ApiRef<
  OAuthApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({ id: 'auth.github' });

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: giteaAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        configApi,
        provider: {
          id: 'oauth2',
          title: 'Gitea',
          icon: () => null,
        },
        environment: configApi.getOptionalString('auth.environment'),
        popupOptions: { size: { fullscreen: true } },
      }),
  }),

  createApiFactory({
    api: githubAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        configApi,
        provider: {
          id: 'github',          // MUST match auth.providers.github
          title: 'GitHub',
          icon: () => null,
        },
        environment: configApi.getOptionalString('auth.environment'),
        popupOptions: { size: { fullscreen: true } },
      }),
  }),

  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: kubernetesAuthProvidersApiRef,
    deps: {
      microsoftAuthApi: microsoftAuthApiRef,
      googleAuthApi: googleAuthApiRef,
    },
    factory: ({ microsoftAuthApi, googleAuthApi }) =>
      new KubernetesAuthProviders({ microsoftAuthApi, googleAuthApi }),
  }),

  createApiFactory({
    api: kubernetesApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      kubernetesAuthProvidersApi: kubernetesAuthProvidersApiRef,
    },
    factory: ({ discoveryApi, fetchApi, kubernetesAuthProvidersApi }) =>
      new KubernetesBackendClient({ discoveryApi, fetchApi, kubernetesAuthProvidersApi }),
  }),

  createApiFactory({
    api: grafanaQueryApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new GrafanaQueryClient({ discoveryApi, fetchApi }),
  }),
];
